import { usePermissions as useRaPermissions } from 'react-admin';

export const usePermissions = () => {
	const { permissions, isLoading } = useRaPermissions();
	
	// 例: string 型で返ってくる "admin", "user" などに基づき boolean を返す
	const isAdmin = permissions === 'admin';
	const isUser = permissions === 'user';
	
	return {
		permissions,
		isLoading,
		isAdmin,
		isUser,
	};
};